var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 49.829 49.829",
    viewBox: "0 0 49.829 49.829",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m43.302 7.914c-0.249 0-0.499-0.093-0.692-0.279-0.398-0.382-0.411-1.016-0.028-1.414 1.038-1.08 1.59-2.29 1.407-3.082-0.118-0.509-0.576-0.912-1.362-1.199-0.519-0.189-0.785-0.764-0.596-1.283s0.765-0.783 1.283-0.596c1.819 0.665 2.431 1.796 2.623 2.627 0.342 1.478-0.374 3.316-1.914 4.92-0.197 0.203-0.458 0.306-0.721 0.306z",
    fill: "#659C35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m32.238 15.303c-0.137 0.467-0.272 0.963-0.4 1.526-3.5 15.417-16.372 23.55-30.887 31.589-0.664 0.368-0.755 1.503-0.103 1.405 9.352-1.406 33.762 0.965 45.701-27.013 0 0 6.163-12.856-1.712-14.981 1e-3 0-10.887-5.115-12.599 7.474z",
    fill: "#D13834"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m48.974 17.608c0.892-4.035 0.86-8.868-3.839-10.136 0 0-10.635-4.987-13.19 6.315 2.49-0.189 5.827-0.69 6.761-2.029 0 0 2.21 2.21 1.072 5.358 0 0 4.688-0.536 4.286-4.286 0 0 2.88 2.478 2.143 6.429-1e-3 0 1.389-0.421 2.767-1.651z",
    fill: "#88C057"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14.928 45.996c-0.423 0-0.815-0.27-0.952-0.693-0.169-0.525 0.119-1.089 0.645-1.259 21.656-6.978 24.045-21.793 24.067-21.941 0.079-0.547 0.587-0.937 1.133-0.846 0.547 0.079 0.925 0.586 0.846 1.133-0.096 0.658-2.602 16.201-25.433 23.559-0.102 0.031-0.205 0.047-0.306 0.047z",
    fill: "#F75B57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatOn);
export default __webpack_public_path__ + "static/media/heat_on.f8511c3fefca5ca66064ff77ddd26095.svg";
export { ForwardRef as ReactComponent };